import React from "react";

const Soon = () => {
  return (
    <div
      className="screenContainer"
      style={{
        height: "100vh",
        justifyContent: "center",
        fontSize: 40,
        color: "white",
        textAlign: "center",
      }}
    >
      MORE CHAPTERS WILL BE ADDED SOON
      <a
        href="/"
        style={{
          color: "rgb(171, 25, 255)",

          fontSize: 30,
        }}
      >
        Go Home
      </a>
    </div>
  );
};

export default Soon;
